import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { eventMomentFactory } from '../../../data/misc/eventMomentFactory';
import styles from './EventTimezone.module.scss';

const EventTimezone = (props) => {
    const { event, className = '', alt = null } = props,
        today = moment().startOf('day'),
        eventToday = eventMomentFactory(event, today.format('L'), 'L').startOf(
            'day'
        );

    if (!event) return alt;
    if (today.utcOffset() == eventToday.utcOffset()) return alt;

    return (
        <span className={[styles.EventTimezone, className].join(' ')}>
            <FontAwesomeIcon
                className={styles.icon}
                icon={faClock}
                aria-hidden='true'
            />
            {event.event_timezone}
        </span>
    );
};

export default EventTimezone;
